export default __webpack_public_path__ + "static/media/car-6.437f392a.png";